import { ClickAnalyticsPlugin } from '@microsoft/applicationinsights-clickanalytics-js';
import { ReactPlugin } from '@microsoft/applicationinsights-react-js';
import {
    ApplicationInsights,
    IDependencyTelemetry,
} from '@microsoft/applicationinsights-web';
import { createBrowserHistory } from 'history';

export const reactPlugin = new ReactPlugin();
const browserHistory = createBrowserHistory();
const clickPlugin = new ClickAnalyticsPlugin();

export const appInsights = new ApplicationInsights({
    config: {
        connectionString:
            process.env.REACT_APP_APPLICATION_INSIGHTS_CONNECTION_STRING,
        extensions: [reactPlugin],
        extensionConfig: {
            [reactPlugin.identifier]: { history: browserHistory },
            [clickPlugin.identifier]: { autoCapture: true },
        },
        disableExceptionTracking: false,
        disableAjaxTracking: false,
        enableUnhandledPromiseRejectionTracking: true,
        enableAutoRouteTracking: true,
        autoTrackPageVisitTime: true,
        enableDebug: true,
    },
});

let isAppInsightsInitialized = false;

export const initializeAppInsights = () => {
    if (isAppInsightsInitialized || process.env.NODE_ENV !== 'production') {
        return;
    }
    try {
        appInsights.loadAppInsights();
        appInsights.trackPageView();
        isAppInsightsInitialized = true;
        console.log('App Insights initialized');
    } catch (error) {
        // a failed SDK load must not crash the app (it runs inside a useEffect under AppInsightsErrorBoundary)
        console.error('App Insights failed to initialize', error);
    }
};

export const trackError = (
    error: Error,
    properties?: Record<string, string>
) => {
    if (isAppInsightsInitialized) {
        appInsights.trackException({ exception: error, properties });
    }
};

// Manually track a dependency failure (business logic failure with HTTP 200/201).
export const trackDependencyFailed = (
    dependency: Omit<IDependencyTelemetry, 'success'>
) => {
    if (isAppInsightsInitialized) {
        appInsights.trackDependencyData({ ...dependency, success: false });
    }
};
